document.addEventListener("DOMContentLoaded", function () {
  const ratingPill = document.querySelector(".givaMG__ratingPill");

  if (ratingPill) {
    ratingPill.addEventListener("click", function (e) {
      e.preventDefault();

      const reviewSection = document.querySelector("#judgeme_product_reviews");

      if (reviewSection) {
        reviewSection.scrollIntoView({
          behavior: "smooth"
        });
      }
    });
  }
});


// *********** Swiper ************* //
 var swiper = new Swiper(".myOfferSwiper", {
      slidesPerView: 1,
      spaceBetween: 4,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
        900: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        1450: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
      },
    });



    var swiper = new Swiper(".myFeatureSwiper", {
      slidesPerView: 2,
      spaceBetween: 4,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 4,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 4,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 6,
        },
        1450: {
          slidesPerView: 4,
          spaceBetween: 6,
        },
      },
    });

// read more and read less content js
document.addEventListener("DOMContentLoaded", function () {
    
    let count = 0;

    document.querySelectorAll(".show_hide_content").forEach(function (element) {

        count++;

        // Create wrapper div
        const wrapper = document.createElement("div");
        wrapper.className = "full_wrap seo_inner_content";
        wrapper.id = "content_inner_" + count;

        // Move existing content inside wrapper
        while (element.firstChild) {
            wrapper.appendChild(element.firstChild);
        }

        element.appendChild(wrapper);

        // Create show/hide button
        const anchor = document.createElement("a");
        anchor.href = "javascript:void(0);";
        anchor.className = "show_hide_anchor";
        anchor.setAttribute("data-id", wrapper.id);
        anchor.textContent = "+ Show More";

        element.appendChild(anchor);
    });

    // Add classes to headings
    document.querySelectorAll(
        ".show_hide_content h1, " +
        ".show_hide_content h2, " +
        ".show_hide_content h3, " +
        ".show_hide_content h4, " +
        ".show_hide_content h5, " +
        ".show_hide_content h6"
    ).forEach(function (heading) {
        heading.classList.add("common_header", "light");
    });

    // Click event delegation
    document.addEventListener("click", function (e) {

        if (e.target.classList.contains("show_hide_anchor")) {

            const button = e.target;

            button.classList.toggle("active");

            if (button.classList.contains("active")) {
                button.textContent = "- Show Less";
            } else {
                button.textContent = "+ Show More";
            }

            const parent = button.closest(".show_hide_content");
            const content = parent.querySelector(".seo_inner_content");

            content.classList.toggle("active");

            if (content.classList.contains("active")) {

                const contentHeight = content.scrollHeight;
                content.style.maxHeight = contentHeight + "px";

            } else {

                content.style.maxHeight = "";
            }
        }
    });

});

// $(document).ready(function () {

//     let count = 0;

//     $('.show_hide_content').each(function () {

//         count++;

//         $(this).wrapInner('<div class="full_wrap seo_inner_content" id="content_inner_' + count + '"></div>');

//         $(this).append('<a href="javascript:void(0);" class="show_hide_anchor" data-id="content_inner_' + count + '">+ Show More</a>');
//     });

//     $('.show_hide_content h1,.show_hide_content h2,.show_hide_content h3,.show_hide_content h4,.show_hide_content h5,.show_hide_content h6').addClass("common_header light");

//     $(document).on("click", ".show_hide_anchor", function () {

//         $(this).toggleClass("active");

//         if ($(this).hasClass("active")) {
//             $(this).text("- Show Less");
//         } else {
//             $(this).text("+ Show More");
//         }

//         $(this).parents(".show_hide_content").find(".seo_inner_content").toggleClass("active");

//         if ($(this).parents(".show_hide_content").find(".seo_inner_content").hasClass("active")) {

//             let id = $(this).attr("data-id");

//             var content = document.getElementById(id);

//             var contentHeight = content.scrollHeight;

//             content.style.maxHeight = contentHeight + "px";

//         } else {

//             let id = $(this).attr("data-id");

//             $('#' + id).removeAttr("style");
//         }
//     });

// });


// document.addEventListener("DOMContentLoaded", function () {
//   function toggleSlideshowArrows() {
//     document.querySelectorAll("slideshow-component").forEach(function (slideshow) {
//       var slides = slideshow.querySelectorAll("slideshow-slides .card");
//       var arrows = slideshow.querySelector("slideshow-arrows");

//       if (!slides.length || !arrows) return;

//       var hasHiddenTrue = false;

//       slides.forEach(function (slide) {
//         if (slide.getAttribute("aria-hidden") === "true") {
//           hasHiddenTrue = true;
//         }
//       });

//       if (hasHiddenTrue) {
//         arrows.style.display = "";
//       } else {
//         arrows.style.display = "none";
//       }
//     });
//   }

//   toggleSlideshowArrows();

//   document.querySelectorAll("slideshow-component").forEach(function (slideshow) {
//     var slides = slideshow.querySelectorAll("slideshow-slides .card");

//     if (!slides.length) return;

//     var observer = new MutationObserver(function () {
//       toggleSlideshowArrows();
//     });

//     slides.forEach(function (slide) {
//       observer.observe(slide, {
//         attributes: true,
//         attributeFilter: ["aria-hidden"]
//       });
//     });
//   });
// });